export const getProperAge = () =>
  new Date().getHours() < 15 ? "morning" : "evening";
